import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

// Constants
import { LONG_HUMAN_DATE_TIME_FORMAT } from 'constants';

// Components
export default class Clock extends React.Component {
  static propTypes ={
    format: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    format: LONG_HUMAN_DATE_TIME_FORMAT
  };

  constructor() {
    super();
    this.setTimeout = this.setTimeout.bind(this);
  }

  componentWillMount() {
    this.setTimeout();
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  setTimeout() {
    this.timeout = window.setTimeout(() => {
      this.forceUpdate();
      this.setTimeout();
    }, 30000);
  }

  render() {
    const { format, className, ...passed } = this.props;

    return (
      <div {...passed} className={classNames(className, 'clock')}>{moment().format(format)}</div>
    );
  }
}
